<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }" :title="enterpriseFullName+'/员工列表'">
    <div class="card-body-content">
      <div class="title-box">
        <span>部门</span>
        <a-space>
          <!--          <a-button style="padding: 0 60px" type="primary" @click="onSubmitEvent">提交</a-button>-->
          <a-button type="primary" icon="plus" @click="onAddEvent">新建</a-button>
          <!--          <a-button @click="onAddEvent">批量导入</a-button>-->
        </a-space>
      </div>
      <div class="tab-content-box" ref="tableBoxRef">
        <a-table
          :defaultExpandAllRows="true"
          rowKey="deptId"
          :columns="columns"
          :data-source="deptTreeData"
          :expanded-row-keys.sync="expandedRowKeys"
          :scroll="{x:0,y:480}"
          :pagination="false">
          <a-space slot="action" slot-scope="text, record">
            <a @click.stop="onEditEvent(record)">编辑</a>
            <!--            <a @click.stop="onDeleteEvent(record)">删除</a>-->
            <a @click.stop="addNodeEvent(record,true)">添加子节点</a>
            <a @click.stop="addNodeEvent(record,false)">添加同级节点</a>
            <!--            <a @click.stop="onMoveEvent(2, record)">上移</a>-->
            <!--            <a @click.stop="onMoveEvent(1, record)">下移</a>-->
          </a-space>
        </a-table>
      </div>
    </div>
    <SimpleFormEditorDialog
      v-if="showDialog"
      @cancel="showDialog=false"
      :title="selectItem&&selectItem.deptId?'编辑部门':'新增部门'"
      :rules="rules"
      :editConfigList="editConfigList"
      :item="selectItem"
      @ok="onEditResultEvent"
    ></SimpleFormEditorDialog>
    <ImportSimpleDataDialog
      v-if="showImportSimpleDataDialog"
      :extraData="{enterpriseId:enterpriseId}"
      @cancel="showImportSimpleDataDialog=false"
      @ok="refreshData(true)"
      :uploadPromise="requestUpload"
    ></ImportSimpleDataDialog>
  </a-card>
</template>
<script>
import {
  insertChildNode,
  insertSiblingNode,
  removeNodeFromTreeArray,
  replaceNode,
  updateSorting
} from '@/utils/TreeHelper'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import employeeOptions from '@/views/platform/employeeVerification/mixins/employeeMixins'
import deptMixins from '@/views/platform/employeeVerification/mixins/deptMixins'
import ImportSimpleDataDialog from '@/customComponents/ImportSimpleDataDialog.vue'
import ImportEmployeeDataDialog from '@/views/platform/employeeVerification/dialog/ImportEmployeeDataDialog.vue'

export default {
  name: 'OrganizationalStructure',
  components: {
    ImportEmployeeDataDialog,
    SimpleFormEditorDialog: SimpleFormEditorDialog,
    ImportSimpleDataDialog: ImportSimpleDataDialog
  },
  mixins: [deptMixins, employeeOptions],
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      showImportSimpleDataDialog: false,
      isChild: false,
      isEdit: false,
      showDialog: false,
      tableHeight: '100%',
      enterpriseId: '',
      enterpriseFullName: '深圳某某股份有限公司',
      tDataList: [],
      expandedRowKeys: [],
      columns: [
        {
          title: '部门名称',
          dataIndex: 'deptName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '360px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],

      editConfigList: [
        {
          name: '部门名称',
          key: 'deptName',
          placeholder: '请输入部门名称'
        }
      ],
      rules: {
        name: [{ required: true, message: '请输入部门名称', trigger: 'change' }]
      },
      selectItem: undefined
    }
  },
  mounted() {
    this.tableHeight = this.$refs.tableBoxRef.offsetHeight
  },

  methods: {
    addNodeEvent(record, isChild) {
      this.isEdit = false
      this.isChild = isChild
      this.selectItem = {
        pdeptId: isChild ? String(record.deptId) : record.pdeptId
      }
      this.showDialog = true
    },
    onDeleteEvent(record) {
      this.tDataList = removeNodeFromTreeArray(this.tDataList, record.id)
    },
    // onMoveEvent(type, record) {
    //   const msg = type === 2 ? '上移' : '下移'
    //   const success = updateSorting(record.id, type === 2, this.tDataList)
    //   if (success) {
    //     this.$message.success(msg + '成功')
    //     this.tDataList = JSON.parse(JSON.stringify(this.tDataList))
    //   } else {
    //     this.$message.error(msg + '失败')
    //   }
    // },
    refreshData() {
      this.getTreeData(this.enterpriseId)
    },
    onEditResultEvent(params) {
      const data = {
        enterpriseId: this.enterpriseId,
        pdeptId: this.selectItem ? this.selectItem.deptId : 0,
        ...params
      }
      this.getHttpServices().getMemberAuthService().post('member/v3/auth/saveAuthDepartment', data)
        .then(res => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          this.refreshData()
          if (this.isChild && !this.expandedRowKeys.includes(data.pdeptId)) {
            this.expandedRowKeys = [...this.expandedRowKeys, ...data.pdeptId]
          }
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })

      // if (this.isEdit) {
      //   const newItem = {
      //     ...params,
      //   }
      //   const list = replaceNode(this.tDataList, this.selectItem.id, newItem)
      //   this.tDataList = JSON.parse(JSON.stringify(list))
      // } else {
      //   const newItem = {
      //     id: Date.now().toString().slice(5),
      //     name: this.form.name
      //   }
      //   if (!this.selectItem) {
      //     this.tDataList = [newItem, ...this.tDataList]
      //   } else {
      //     this.tDataList = this.isChild ? insertChildNode(this.tDataList, this.selectItem.id, newItem) : insertSiblingNode(this.tDataList, this.selectItem.id, newItem)
      //     console.error('---tDataList-11111----', this.tDataList)
      //     if (this.isChild && !this.expandedRowKeys.includes(this.selectItem.id)) {
      //       //展开父级节点
      //       this.$nextTick(() => {
      //         this.expandedRowKeys = [...this.expandedRowKeys, this.selectItem.id]
      //       })
      //     }
      //   }
      // }
    },
    onSubmitEvent() {
      if (!this.tDataList || !this.tDataList.length) {
        this.$message.error('请完善组织结构再提交！')
        return false
      }
    },
    requestUpload(formData) {
      const headers = {
        'Content-Type': 'multipart/form-data'
      }
      return this.getHttpServices().getMemberAuthService().post(`member/v3/auth/employee/import/${this.enterpriseId}`, formData, headers)
    }
  }
}
</script>

<style scoped lang="less">
.card-body-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .title-box {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 22px;
      font-weight: bold;
    }
  }

  .bottom-box {
    //box-shadow: 0 -5px 10px rgba(0,0,0,0.2);
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
  }

  .tab-content-box {
    width: 100%;
    min-height: 480px;
    flex: 1;
  }
}
</style>
<style lang="less">
.ant-card, .ant-table-wrapper .ant-spin-container .ant-spin-nested-loading {
  height: 100% !important;
}
</style>